var DataSourceIdentifier = /** @class */ (function () {
    function DataSourceIdentifier(code) {
        this.code = code;
        if (code === undefined) {
            throw new Error('code can not be undefined.');
        }
        if (code < 0) {
            throw new Error('code can not less than zero.');
        }
    }
    DataSourceIdentifier.equals = function (x, y) {
        if (x === y) {
            return true;
        }
        if (x === undefined) {
            return false;
        }
        if (y === undefined) {
            return false;
        }
        if (typeof x !== typeof y) {
            return false;
        }
        return x.code === y.code;
    };
    DataSourceIdentifier.tryParse = function (code) {
        if (code === undefined) {
            return undefined;
        }
        if (code < 0) {
            return undefined;
        }
        return new DataSourceIdentifier(code);
    };
    return DataSourceIdentifier;
}());
export { DataSourceIdentifier };
